module.exports = __webpack_public_path__ + "img/kongshuju.1766306608134.png";